import { PersistentError } from './PersistentError';
export class IllegalEntityError extends PersistentError {
    /**
     * @param entity - The entity which cause the error
     */
    constructor(entity) {
        super(`Entity ${entity} is not a valid entity`);
        this.entity = entity;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWxsZWdhbEVudGl0eUVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiSWxsZWdhbEVudGl0eUVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxlQUFlLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUdwRCxNQUFNLE9BQU8sa0JBQW1CLFNBQVEsZUFBZTtJQU1yRDs7T0FFRztJQUNILFlBQVksTUFBYztRQUN4QixLQUFLLENBQUMsVUFBVSxNQUFNLHdCQUF3QixDQUFDLENBQUM7UUFDaEQsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7SUFDdkIsQ0FBQztDQUNGIn0=